<div class="counter-container">
  <div [class]="'circle-counter ' + type">
    <div class="counter">{{counter | numberToK}}</div>
  </div>
  <div class="counter-label">{{label}}</div>
  <div class="counter-label leave-space">{{underLabel}}</div>
</div>
